export function getActionError(error, fallback = "The action failed. Please try again.") {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  const errors = data?.errors;
  const reasons = Array.isArray(errors)
    ? errors.map((item) => typeof item === "string" ? item : item?.reason)
    : errors && typeof errors === "object" ? Object.values(errors).flat() : [];
  const message = reasons.filter((item) => typeof item === "string" && item.trim()).join(" ");
  return message || (typeof data?.detail === "string" && data.detail) || (typeof data?.message === "string" && data.message) || fallback;
}
